import React, { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';

interface RouteConfig {
  default_route: string;
  route_prefix: string;
  current_pipeline?: string;
}

interface RouteContextType {
  defaultRoute: string;
}

const RouteContext = createContext<RouteContextType | undefined>(undefined);

export const RouteProvider: React.FC<{ defaultRoute: string; children: React.ReactNode }> = ({
  defaultRoute,
  children
}) => {
  return (
    <RouteContext.Provider value={{ defaultRoute }}>
      {children}
    </RouteContext.Provider>
  );
};

export const useRoute = () => {
  const context = useContext(RouteContext);
  if (context === undefined) {
    throw new Error('useRoute must be used within a RouteProvider');
  }

  const location = useLocation();
  const currentPath = location.pathname;

  // Extract pipeline name from current path
  const pathMatch = currentPath.match(/^\/([^/]+)/);
  const currentPipeline = pathMatch ? pathMatch[1] : context.defaultRoute;

  // Create a pipeline-specific routeConfig
  const routeConfig: RouteConfig = {
    default_route: context.defaultRoute,
    route_prefix: `/${currentPipeline}`,
    current_pipeline: currentPipeline
  };

  return {
    routeConfig
  };
};

export default RouteContext;
